export const EXPIRE_HOURS = 5;
